import { useState, useRef } from 'react';
import { useForm } from "react-hook-form";

import { ReactComponent as Cancel } from '../assets/cancel.svg';

import { Editor } from './Editor';

export default function UITexts ({value, saveUITexts, hideUITexts}) {

	console.log(value);

    const texts_default = {
		registration_consent: {
			hint: "Consent to receive promotional communications",
			value: {
				default_text: "I consent to receive promotional communications (which may include phone, email, and social). I understand I may proactively opt out of communications at anytime.",
			}
		},
		registration_agree: {
			hint: "Consent to use of personal information",
			value: {
				default_text: "By clicking submit, I agree to the use of my personal information in accordance with Privacy Policy.",
			}
		},
    };

    var texts = texts_default;

	console.log(value);

	if (value) {

		for (let key in texts_default){
			if(value[key]['value'])
				texts[key]['value'] = value[key]['value'];
		}
    }

    const {
		register,
		reset,
		setValue,
		handleSubmit,
		formState: { errors },
    } = useForm();

    const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

    const saveButton = (data) => {

	console.log(data);
        saveUITexts (data['texts']);
        hideUITexts ();
    }

    const changeEditor = (data) => {
    }

    return (

		<div className="right right_logo texts">
			<div className="dashed-border">
				<div className="title">
					<div>
						<div className="name">UI Texts</div>
					</div>
					<div>
						<div className="cancel" onClick={hideUITexts}>
						<Cancel/>
						</div>
					</div>
				</div>

				<form className="">

					{!!texts &&

						Object.keys(texts).map( (key, index) =>

							<div key={index}>

								<div className="subtitle">
									{texts[key].hint}
								</div>

								<textarea
									{...register("texts["+key+"].value.text")}
									placeholder={texts[key].value.default_text}
									defaultValue={texts[key].value.text ? texts[key].value.text : texts[key].value.default_text}
								>
								</textarea>

							</div>
						)
					}

					<button type="submit" className="button check save" onClick={handleSubmit(saveButton)}>
						Save
					</button>

					<div className="error">{ message }</div>

				</form>

			</div>

	    </div>

    )

}
